export default {
  vabI18n: {
    首页: 'Home',
  },
}
